module.exports = __webpack_public_path__ + "static/media/crowdstrike-logo.deb05615.png";